// Copyright © 2026 Phaena Management B.V. All rights reserved.
// Proprietary and confidential. See COPYRIGHT.md in the repository root.

import { Routes, Route, Navigate } from "react-router-dom"
import { AppShell } from "./components/AppShell"
import { Landing } from "./pages/Landing"
import { Privacy } from "./pages/Privacy"

function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Landing />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export default App
